export const formatPrice = (price) => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const formatToColombianPesos = (value) => {
  // Remove any non-numeric characters
  const numericValue = value.replace(/\D/g, '');

  // Format as Colombian Pesos
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  }).format(numericValue);
};

export const calculateDaysDiff = (createdAt) => {
  const creationDate = new Date(createdAt);
  const today = new Date();
  const differenceInTime = today - creationDate;
  return differenceInTime / (1000 * 3600 * 24);
};
